import { ContentTypeHeaders } from 'src/core/Constants';

export const useAuthorizationHeader = (token: string) => {
  return { Authorization: `Bearer ${token}` };
};

export const useContentTypeHeader = (headerValue: ContentTypeHeaders) => ({
  'Content-Type': `${headerValue}`,
});
